;(function () {
  var methods = ['identify', 'register', 'track']
  var metrics = {}

  function getCurrentOpal() {
    var opal

    if (!window.AppBase) return null

    opal = window.AppBase.request('opals:get_current_opal')
    return opal
  }

  function getCurrentUser() {
    var opal

    if (!window.AppBase) return null

    opal = window.AppBase.request('users:get_current_user')
    return opal
  }

  function getUserSegments() {
    var user = getCurrentUser()
    if (user.get('user_profile') && user.get('user_profile').get('segments')) {
      return user.get('user_profile').get('segments')
    } else {
      return []
    }
  }

  function getCurrentWorkspace() {
    var state = window.OpalMoments && window.OpalMoments.State
    if (!state) return null

    var workspace

    try {
      workspace = state.current_brand
      // eslint-disable-next-line no-empty
    } catch {}
    if (workspace) return workspace

    try {
      workspace = OpalMoments.Collections.brands.get(
        state.settings.get('current_brand_id')
      )
      // eslint-disable-next-line no-empty
    } catch {}
    return workspace
  }

  function updateIntercomConfig() {
    var user = getCurrentUser()
    var opalId
    var opalUuid
    var opalStatus
    var opal = getCurrentOpal()

    if (opal) {
      opalId = opal.get('id')
      opalUuid = opal.get('uuid')
      opalStatus = opal.get('status')
    }

    if (user) {
      var email = user.get('email') || user.get('user_profile').get('email')
      var intercomSettings = {
        user_id: user.get('uuid'),
        userUuid: user.get('uuid'),
        opalUserId: user.id,
        opalId: opalId,
        opalPlan: getOpalPlan(opal),
        opalUuid: opalUuid,
        opalStatus: opalStatus,
        opalType: getOpalType(),
        isActive: true,
        roleName: Opal.State.this_user_role,
        segment1: getUserSegments()[0],
        segment2: getUserSegments()[1],
        email: email,
        name: user.get('full_name'),
        app_id: 'hv1psobs',
        hide_default_launcher: true,
        custom_launcher_selector: '.kuiper-intercom-button',
        creationDate: user.get('created_at'),
        opalVersion: window.OPAL_SERVER_APPLICATION_VERSION || 'unknown',
      }
      window.intercomSettings = intercomSettings
    }
  }

  // `AppBase.data` may not be set up when this file is parsed.
  function getShortname() {
    try {
      return window.AppBase.data.global_config.analytics_shortname
    } catch {
      return undefined
    }
  }
  function getOpalType() {
    var shortname = getShortname()
    if (!shortname) return
    if (shortname === 'teams') {
      return 'standard'
    } else {
      return 'enterprise'
    }
  }
  function getOpalPlan(opal) {
    if (!opal.get('plan')) return 'enterprise'
    return opal.get('plan').system_name
  }
  methods.forEach(function (method) {
    var callback = function () {}

    metrics[method] = function () {
      var cleanArguments = [].slice.call(arguments)

      try {
        if (callback) {
          callback.apply(window, cleanArguments)
        }
      } catch (e) {
        window.trackJs.track(e)
      }
    }
  })

  metrics.opalTrack = function (event, inMetadata) {
    var metaData = inMetadata || {}
    metaData.sessionID =
      window.userAnalytics.sessionID ||
      window.CREATOR_GUID ||
      window.generateUUID()
    var workspace = getCurrentWorkspace()
    if (workspace) metaData.Workspace = workspace.get('name')

    metrics.track(event, metaData)

    if (getCurrentUser()) {
      updateIntercomConfig()
    }
  }
  window.metrics = metrics
})()
